module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("l4Y4E"))).then(() => parcelRequire('hEqeo'));